import React, { ReactNode } from 'react';

interface AnimationProviderProps {
  children: ReactNode;
}

const AnimationProvider: React.FC<AnimationProviderProps> = ({ children }) => {
  return <>{children}</>;
};

export default AnimationProvider; 